import styled from '@emotion/styled';
import { color, typography } from '@uniquegood/realworld-studio-design';

interface PageHeaderProps {
  planName: string;
  userName?: string;
}

const PageHeader = ({ planName, userName }: PageHeaderProps) => {
  return (
    <Container>
      <Title>{planName} 요금제를 적용할 채널을 선택해 주세요</Title>
      <Subtitle>
        {userName ? `${userName}님이` : '당신이'} 소유자로 있는 채널에만 {planName} 요금제 적용이
        가능해요.
      </Subtitle>
    </Container>
  );
};

export default PageHeader;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 8px 0;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 28px;
  line-height: 32px;
  font-weight: ${typography.weight.bold};
  color: ${color.text_default};
  margin: 0;
`;

const Subtitle = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: ${typography.weight.regular};
  color: #8f8f8f;
  margin: 0;
`;
